
import LogInPage from "./view/index";


export const LogInView = () => {
    return <LogInPage/>
}